import SkeletonLink from "components/common/skeleton-link"
import { useTranslation } from "lib/i18n/translation"
import { useMainCategories } from "lib/tools/categories"

export const Short = ({ film, loading }) => {
	if (loading || film.recommendersIds.length === 0) {
		// Tricks pour corriger un bug React qui a tendance à écraser la section suivante
		return <section className="short" />
	}

	const { c } = useTranslation("common")
	const { allLists } = useMainCategories()

	return (
		<section className="short">
			<p className="is-recommended">
				<b>{c("also-recommended-by")}</b>
				{film.recommendersIds.map((id, index) => {
					const list = allLists.find(l => l.director.id == id)

					if (!list) return null

					return (
						<SkeletonLink
							key={`recommender-${index}`}
							href={`/lists/[id]`}
							as={`/lists/${c(list.linkRewrite)}`}
						>
							<a title={c("see-list")}>
								{list.name.replace(" | ", " ")}
							</a>
						</SkeletonLink>
					)
				})}
			</p>
		</section>
	)
}
